import React, { useEffect } from "react";
import styles from "./searchModal.scss";
import { getRouter, getQueryUTMString } from "@tw/shared-ui-components/lib/utils/helper";
import { Background } from "./background/background";
import { ModalWrapper } from "./modalwrapper/modalWrapper";
import { getHotTopics } from "../search/utils";
import { SEARCH_TYPES } from "../../utils/constants";

export const SearchModal = (props) => {
  const {
    showModal,
    setShowModal,
    text,
    setText,
    suggestions,
    setSuggestions,
    isDropdownHidden,
    histories,
    setHistory,
    hotTopics,
    setHotTopics,
    foundElementSkuCode,
    setFoundElementSkuCode,
    headerDesktopRef,
    loading,
    onChangeHandler,
    setIsDropdownHidden,
    desktopSearchRef,
    actualSuggestionCount,
  } = props;

  const router = getRouter();
  const SuggestionNotFoundContent = () => {
    return (
      <div className={styles["suggesion_not_found_container"]}>
        <div className={styles.suggesion_not_found_text}>
          請確認輸入的文字是否有誤，請嘗試重新搜尋
        </div>

        <div className={styles["searches_options"]}>
          {hotTopics &&
            hotTopics.map((value, valueIndex) => {
              return (
                <label key={valueIndex} className={styles["labl"]}>
                  <input
                    type="radio"
                    value={value}
                    name="searches_radio_btns"
                    autoComplete="off"
                    //onChange={(e) => setText(e.target.value)}
                    onChange={() => {
                      router.push(
                        `/search/${value}?type=${SEARCH_TYPES.SUGGESTED}${getQueryUTMString('?')}`
                      );
                      setShowModal(false);
                    }}
                  //checked={text === value}
                  />
                  <div className={styles.search_btn}>
                    <span className={styles["search_btn_text"]}>{value}</span>
                  </div>
                </label>
              );
            })}
        </div>
      </div>
    );
  };

  const clearSearchHandler = (item) => () => {
    setHistory(histories.filter((val) => item != val));
    localStorage.setItem(
      "AmwTwRecentSearches",
      JSON.stringify(histories.filter((val) => item != val))
    );
  };

  const removeAllHandler = () => {
    setHistory([]);
    localStorage.setItem("AmwTwRecentSearches", JSON.stringify(""));
  };

  const selectRecentSearch = (item) => () => {
    setText(item);
    onChangeHandler(item);
  };

  const Recentlysearched = (text) => {
    return (
      histories &&
      histories.some(function (item) {
        return item == text;
      })
    );
  };

  const updateLocalStorage = () => {
    let newHistories = [];
    newHistories = histories;
    const capitalizeText = text.charAt(0)?.toUpperCase() + text.slice(1);

    if (
      !Recentlysearched(capitalizeText) &&
      histories &&
      histories.length != 5
    ) {
      newHistories = histories;
      newHistories.push(capitalizeText);
    } else {
      if (!Recentlysearched(capitalizeText) && histories) {
        newHistories = histories.slice(1);
        newHistories.push(capitalizeText);
      }
    }
    setHistory(newHistories);
    localStorage.setItem("AmwTwRecentSearches", JSON.stringify(newHistories));
  };

  const onSuggestHandler = (skuName, skuCode) => {
    router.push(`/products/${skuCode}${getQueryUTMString('?')}`);
    setShowModal(false);
    updateLocalStorage();
    setFoundElementSkuCode(skuCode);
    // setText("");
    // if (typeof window !== undefined)
    //   document.getElementById("inputSearchDesktop").value = "";
    setText("");
    setIsDropdownHidden(true);
    setSuggestions([]);
  };

  const splitSuggestion = (searchText) =>
    searchText &&
    searchText.split(new RegExp(`(${text})`, `gi`)).map((subPart, i) => {
      return (
        <span
          style={{
            color:
              subPart.toLowerCase() === text.toLocaleLowerCase()
                ? "#38539a"
                : "black",
          }}
        >
          {subPart}
        </span>
      );
    });

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [showModal]);

  useEffect(async () => {
    const hotTopics = await getHotTopics();
    setHotTopics(hotTopics);
  }, []);

  return (
    <>
      {showModal ? (
        <Background
          setShowModal={setShowModal}
          showModal={showModal}
          headerDesktopRef={headerDesktopRef}
        >
          <ModalWrapper
            showModal={showModal}
            desktopSearchRef={desktopSearchRef}
          >
            <div className={styles.search_area1}>
              {suggestions.length != 0 ? (
                suggestions &&
                  ((!isNaN(text) && text.length > 2) || isNaN(text)) ? (
                  <>
                    <div className={styles["count"]}>
                      找到 {actualSuggestionCount} 個商品{" "}
                      <div className={styles["show_all_result"]} onClick={() => {
                        if (location.pathname.includes("/search/")) {
                          router.replace(`/search/${text}?type=${SEARCH_TYPES.DIRECT}${getQueryUTMString('&')}`);
                        } else {
                          router.push(`/search/${text}?type=${SEARCH_TYPES.DIRECT}${getQueryUTMString('&')}`);
                        }
                        setShowModal(false);
                      }
                      }>顯示全部搜尋結果</div>
                    </div>
                    {suggestions.map((suggestion, i) => (
                      <div
                        key={i}
                        className={styles["suggesion"]}
                        onClick={(e) => {
                          onSuggestHandler(
                            suggestion.skuName,
                            suggestion.skuCode
                          );
                        }}
                        style={{
                          paddingBottom: suggestions.length - 1 != i && "10px",
                          borderBottom:
                            suggestions.length - 1 != i &&
                            "1px dashed rgba(228, 228, 228, 0.7)",
                          marginRight: "10px",
                        }}
                      >
                        <div className={styles["search_icon"]}>
                          <svg
                            width="15"
                            height="15"
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M11.9499 10.7567L15.608 14.4148C15.7496 14.5564 15.7496 14.7854 15.608 14.9271L14.927 15.6081C14.7854 15.7497 14.5564 15.7497 14.4148 15.6081L10.7567 11.95C10.6904 11.8807 10.6512 11.7903 10.6512 11.6939V11.2961C9.55138 12.2453 8.12008 12.8208 6.5532 12.8208C3.09098 12.8208 0.285645 10.0155 0.285645 6.55326C0.285645 3.09104 3.09098 0.285706 6.5532 0.285706C10.0154 0.285706 12.8207 3.09104 12.8207 6.55326C12.8207 8.12014 12.2452 9.55144 11.296 10.6513H11.6938C11.7902 10.6513 11.8806 10.6874 11.9499 10.7567ZM1.732 6.55326C1.732 9.21697 3.88949 11.3745 6.5532 11.3745C9.21691 11.3745 11.3744 9.21697 11.3744 6.55326C11.3744 3.88955 9.21691 1.73206 6.5532 1.73206C3.88949 1.73206 1.732 3.88955 1.732 6.55326Z"
                              fill="#949494"
                            />
                          </svg>
                        </div>

                        <div className={styles["recommendation_content"]}>
                          <span className={styles["brand_name"]}>
                            {suggestion.brandName}
                          </span>
                          <div className={styles["content"]}>
                            {splitSuggestion(suggestion.skuCode)}{" "}
                            {splitSuggestion(suggestion.skuName)}
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  !isDropdownHidden && <SuggestionNotFoundContent />
                )
              ) : (
                !isDropdownHidden && <SuggestionNotFoundContent />
              )}
            </div>

            {!suggestions.length && isDropdownHidden && (
              <div className={styles["containers"]}>
                {hotTopics?.length > 0 ? (
                  <div className={styles.recent_searches}>
                    <div className={styles.recent_srch}>熱門搜尋</div>

                    <div className={styles["searches_options"]}>
                      {hotTopics?.length > 0 &&
                        hotTopics.slice(0, 8).filter(Boolean) &&
                        hotTopics.map((value, valueIndex) => {
                          return (
                            <label key={valueIndex} className={styles["labl"]}>
                              <input
                                type="radio"
                                value={value}
                                name="searches_radio_btns"
                                autoComplete="off"
                                onChange={() => {
                                  router.push(
                                    `/search/${value}?type=${SEARCH_TYPES.SUGGESTED}${getQueryUTMString('&')}`
                                  );
                                  setShowModal(false);
                                  // if (typeof window !== undefined)
                                  //   document.getElementById(
                                  //     "inputSearchDesktop"
                                  //   ).value = value;
                                  setText(value);
                                }}
                                checked={text === value}
                              />
                              <div className={styles.search_btn}>
                                <span className={styles["search_btn_text"]}>
                                  {value}
                                </span>
                              </div>
                            </label>
                          );
                        })}
                    </div>
                  </div>
                ) : null}
                {histories && histories.length > 0 && (
                  <div className={styles["recently_explored_container"]}>
                    <div className={styles["recently_explored_head_bar"]}>
                      <span className={styles["recently_explored_text"]}>
                        最近探索
                      </span>
                      <div className={styles["right_div"]}>
                        <div
                          className={styles["remove_div"]}
                          onClick={removeAllHandler}
                        >
                          <svg
                            width="14"
                            height="15"
                            viewBox="0 0 14 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M10.2504 14.4286C10.9448 14.4285 11.5435 13.866 11.5869 13.173L12.1784 3.71428H12.6249C12.8713 3.71428 13.0713 3.51428 13.0713 3.26785V2.82142C13.0713 2.57499 12.8713 2.37499 12.6249 2.37499H10.3257L9.37708 0.792955C9.16172 0.434101 8.64725 0.142849 8.22872 0.142849H5.41386C4.99533 0.142849 4.48086 0.434101 4.2655 0.792955L3.31684 2.37499H1.01772C0.771288 2.37499 0.571289 2.57499 0.571289 2.82142V3.26785C0.571289 3.51428 0.771288 3.71428 1.01772 3.71428H1.46415L2.05567 13.173C2.09905 13.866 2.69782 14.4285 3.39215 14.4286H10.2504ZM8.76324 2.37499H4.87934L5.41503 1.48213H8.22755L8.76324 2.37499ZM3.39245 13.0893H10.2504L10.8366 3.71428H2.80651L3.39245 13.0893Z"
                              fill="#2C2C2C"
                            />
                          </svg>
                          <span className={styles["remove_text"]}>
                            清空紀錄
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className={styles["recently_explored_items"]}>
                      {histories &&
                        histories.map((item, index) => {
                          return (
                            <div
                              className={styles["item_div"]}
                              style={{
                                borderBottom:
                                  index != histories.length - 1 &&
                                  "1px dashed rgba(228, 228, 228, 0.7)",
                              }}
                            >
                              <div
                                className={styles["search_img"]}
                                onClick={selectRecentSearch(item)}
                              >
                                <svg
                                  width="15"
                                  height="15"
                                  viewBox="0 0 15 15"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M11.9499 10.7567L15.608 14.4148C15.7496 14.5564 15.7496 14.7854 15.608 14.9271L14.927 15.6081C14.7854 15.7497 14.5564 15.7497 14.4148 15.6081L10.7567 11.95C10.6904 11.8807 10.6512 11.7903 10.6512 11.6939V11.2961C9.55138 12.2453 8.12008 12.8208 6.5532 12.8208C3.09098 12.8208 0.285645 10.0155 0.285645 6.55326C0.285645 3.09104 3.09098 0.285706 6.5532 0.285706C10.0154 0.285706 12.8207 3.09104 12.8207 6.55326C12.8207 8.12014 12.2452 9.55144 11.296 10.6513H11.6938C11.7902 10.6513 11.8806 10.6874 11.9499 10.7567ZM1.732 6.55326C1.732 9.21697 3.88949 11.3745 6.5532 11.3745C9.21691 11.3745 11.3744 9.21697 11.3744 6.55326C11.3744 3.88955 9.21691 1.73206 6.5532 1.73206C3.88949 1.73206 1.732 3.88955 1.732 6.55326Z"
                                    fill="#949494"
                                  />
                                </svg>
                              </div>

                              <div
                                className={styles["frequently_searched_text"]}
                                onClick={selectRecentSearch(item)}
                                title={item}
                              >
                                {item}
                              </div>

                              <div
                                className={styles["clear_img"]}
                                onClick={clearSearchHandler(item)}
                              >
                                <svg
                                  width="8"
                                  height="9"
                                  viewBox="0 0 8 9"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.29283 8.0368L7.79302 7.5366C8.06921 7.26041 8.06921 6.81264 7.79302 6.53624L5.54239 4.2856L7.79302 2.03497C8.06921 1.75881 8.06921 1.31102 7.79302 1.03461L7.29283 0.534413C7.01664 0.258223 6.56887 0.258223 6.29246 0.534413L4.04183 2.78504L1.7912 0.534413C1.51503 0.258223 1.06724 0.258223 0.790832 0.534413L0.290638 1.03461C0.0144487 1.3108 0.0144487 1.75856 0.290638 2.03497L2.54127 4.2856L0.290638 6.53624C0.0144487 6.8124 0.0144487 7.26019 0.290638 7.5366L0.790832 8.0368C1.06702 8.31298 1.51503 8.31298 1.7912 8.0368L4.04183 5.78616L6.29246 8.0368C6.56863 8.31298 7.01664 8.31298 7.29283 8.0368Z"
                                    fill="#949494"
                                  />
                                </svg>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                )}
              </div>
            )}
          </ModalWrapper>
        </Background>
      ) : null}
    </>
  );
};
